import React from 'react';
import DataNotFound from '../../assets/img/datanotfound.jpg'
import './index.css'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function DataNot_Found() {
    return (
        <>
            <Helmet> <title>Data not found | GreenDart</title> </Helmet>
            <div className="container mt-5">
                <img src={DataNotFound} alt="" height='350' />
                <h1 className='dnf-header-no'>404</h1>
                <h5 className='dnf-header'>Page not found</h5>
                <p className='dnf-para'>The page you are looking for might have been removed <br /> had its name changed or is temporarily unavailable.</p>
                <Link to={'/'}>
                <button className='dnf-button'>Go to Homepage</button>
                </Link>
            </div>
        </>
    )
}

export default DataNot_Found;